import { FormSubmitButton } from '@if/mui'
import { Stack } from '@mui/material'
import { CreditCard, FileCheck, FileDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { EDisbursementAction } from './disbursement-selection-schema'

// The three disbursement entry points. Each is a real, validated submit of the selection form
// (FormSubmitButton targets the form by id), carrying its action as the submit origin.
const DisburseActions = () => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap justifyContent="flex-end">
      <FormSubmitButton
        origin={EDisbursementAction.AptPay}
        startIcon={CreditCard}
        label={t('disburse.actions.aptPay')}
      />
      <FormSubmitButton
        origin={EDisbursementAction.ApplyCheque}
        startIcon={FileCheck}
        label={t('disburse.actions.applyCheque')}
      />
      <FormSubmitButton
        origin={EDisbursementAction.GenerateAcpFile}
        startIcon={FileDown}
        label={t('disburse.actions.generateDepositFile')}
      />
    </Stack>
  )
}

export default DisburseActions
